var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("main " + (_vm.hasHeader ? 'hasHeader' : '') + " " + (_vm.hasFooter ? 'hasFooter' : '')),style:({paddingTop: _vm.headerHeight/100 + 'rem',
     marginTop: -_vm.headerHeight/100 + 'rem',
     paddingBottom: _vm.footerHeight/100 + 'rem',
     marginBottom: -_vm.footerHeight/100 + 'rem'})},[_c('div',{staticClass:"main-wrapper bg"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5087852b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/AppMain/index.vue
// module id = Exe0
// module chunks = 12